import { Fragment, useEffect, useState } from 'react'
import './GroundstationsAndProviders.css'
import GroundStationProvider from './GsProviders/GroundStationProvider'
import GroundStations from './GroundStations/GroundStations'
import { useParams } from 'react-router-dom'
import GroundStationService from '../../../service/GroundStationService'
import GsMapVisualization from './GSProviderDetails/Modals/GsVisualization/GsMapVisualization'
import CustomToolTip from '../../CommonComponents/CustomToolTip'
import { isEmpty } from 'lodash'

const GroundstationsAndProviders = ({ show_btn_group, set_show_btn_group, loading, setLoading }) => {
    const params = useParams();
    const { mission_id, tab_name } = params
    const [gsProviders, setGsProviders] = useState<any>([])
    const [standAloneGs, setStandAloneGs] = useState<any>([])
    const [allGroundStations, setAllGroundStations] = useState<any>([])

    const [open_map_visualisation_modal, set_open_map_visualisation_modal] = useState<any>(false)
    const [open_provider_config_modal, set_open_provider_config_modal] = useState<any>(false);

    const get_all_ground_stations = async () => {
        try {
            const res = await GroundStationService.getGroundStationsByMissionId();
            if (res?.data) {
                let stand_alone_gs_list = res?.['data'].filter(gs => (gs?.['owner-org'] !== "System" && ((gs?.status === 'Configure' && (!gs?.['properties']?.['provider'] || gs?.['properties']?.['provider'] === '')) || gs?.status === 'Associate With Provider')));
                setAllGroundStations(res?.data);
                setStandAloneGs(stand_alone_gs_list);
            }
        } catch (err: any) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const get_gs_providers = async () => {
        setLoading(true);
        try {
            const res = await GroundStationService.getAllGsProviders(mission_id);
            if (res?.data) {
                setGsProviders(res?.data);
            } else {
                setGsProviders([]);
            }
            await get_all_ground_stations();
        } catch (err: any) {
            console.error(err);
            setLoading(false);
        }
    }


    useEffect(() => {
        if (tab_name !== 'Ground_Stations') return
        if (mission_id && mission_id !== undefined && tab_name === 'Ground_Stations') {
            get_gs_providers()
        }
    }, [mission_id, tab_name])


    return (
        <Fragment>
            <div className='position-relative'>
                <div className='d-flex align-items-center position-absolute gap-2' style={{ top: -70, right: 20 }}>
                    <CustomToolTip title='List View' placement='top'>
                        <button className='p-0 m-0 bg-transparent cursor-auto'>
                            <img src={require('../../../assets/images/svgs/gs/list_selected.svg').default} height={35} alt="list" />
                        </button>
                    </CustomToolTip>
                    <CustomToolTip title='Map View' placement='top'>
                        <button className='p-0 m-0 bg-transparent' onClick={() => { set_open_map_visualisation_modal(true) }}>
                            <img src={require('../../../assets/images/svgs/gs/map.svg').default} height={35} alt="map" />
                        </button>
                    </CustomToolTip>
                </div>
            </div>
            <div className="mission-card-view gap-3">
                <GroundStationProvider
                    gs_providers={gsProviders}
                    all_ground_stations={allGroundStations}
                    get_gs_providers={get_gs_providers}
                    set_loading={(data) => { setLoading(data) }}
                    get_all_ground_stations={() => { get_all_ground_stations() }}
                    open_provider_config_modal={open_provider_config_modal}
                    set_open_provider_config_modal={(data) => { set_open_provider_config_modal(data) }}
                    show_btn_group={show_btn_group}
                    set_show_btn_group={(data) => {
                        set_show_btn_group(data)
                    }}
                    show_info_badge={!isEmpty(standAloneGs)}
                />
                <GroundStations
                    set_loading={(data) => { setLoading(data) }}
                    stand_alone_gs={standAloneGs}
                    set_open_provider_config_modal={(data) => { set_open_provider_config_modal(data) }}
                    get_all_ground_stations={get_all_ground_stations}
                    gs_providers={gsProviders}
                    show_btn_group={show_btn_group}
                    set_show_btn_group={(data) => {
                        set_show_btn_group(data)
                    }}
                    set_open_map_visualisation_modal={(data) => { set_open_map_visualisation_modal(data) }}
                    all_ground_stations={allGroundStations}
                />
            </div>


            {open_map_visualisation_modal &&
                <GsMapVisualization
                    close={() => { set_open_map_visualisation_modal(false) }}
                    ground_stations={allGroundStations}
                    get_all_ground_stations={() => { get_all_ground_stations() }}
                    all_providers={gsProviders}
                    get_provider_details={get_gs_providers}
                    mode={'Map'}
                    open_gs_form={open_map_visualisation_modal === 'Map'}
                />
            }

        </Fragment>
    )
}

export default GroundstationsAndProviders
